<template>
  <div class="sr-textarea">
    <template v-if="!getTextModel">
      <el-input
        :value="value"
        @input="change($event)"
        :disabled="item.disabled"
        :readonly="item.readonly"
        :placeholder="item.placeholder"
        :autosize="item.autosize || false"
        clearable
        type="textarea"
        :rows="item.row || 5"
        :resize="item.resize ? item.resize : 'none'"
      ></el-input>
      <span class="el-input__count" v-if="item.maxlength"
        ><span class="current_length">{{ length }}</span
        >/{{ item.maxlength }}</span
      >
    </template>
    <div v-else>
      {{ value }}
    </div>
  </div>
</template>

<!--
  功能：下拉框组件
  汪振涛
  时间：2020年11月19日 17:09:02
  版本：v1.0
-->
<script>
export default {
  model: {
    prop: "value",
    event: "change"
  },
  name: "SrTextarea",
  components: {},
  props: {
    value: String | Number,
    item: {
      type: Object,
      default: {}
    },
    formComConfig:  {
      type: Object,
      default: {}
    },
  },
  computed: {
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || '' === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
  },
  data() {
    return {
      length: 0
    };
  },
  watch: {
    value: {
      handler: function(params) {
        if (params&&params.trim()) {
          this.length = params.length;
        }1
      },
      immediate:true
    }
  },
  methods: {
    change(value) {
      this.length = value.length;
      this.$emit("change", value);
    },
    search() {
      this.$emit("search");
    }
  },
  mounted() {}
};
</script>




// WEBPACK FOOTER //
// packages/SrTextarea/SrTextarea.vue